<template>
    <v-card tile flat style="overflow-x: hidden !important; overflow-y: hidden !important;">
        <!-- <p class="title mt-3 font-weight-light">{{description}}</p> -->
        <v-card v-if="isMounted" flat tile class="pb-0 pt-4 px-0">
            <component v-if="isMounted" :is="comp" :id="changed" :key="changed" />
        </v-card>
    </v-card> 
</template>
<script>
import SearchAnalysisWidget from "../components/SearchAnalysisWidget.vue";
import SpendingPie from "../components/SpendingPie.vue";
import { groupBySearch, histogramSearch } from "./APIManager.js";
import SpendingTree from "../components/SpendingTree";
import SpendingScatter from "../components/SpendingScatter";
import SpendComparison from './SpendComparison.vue';
import QuarterlyTrends from './QuarterlyTrends.vue';
import ResultsExpiryCycle from "../components/ResultsExpiryCycle.vue";
//import TraceyResults from "./TraceyResults.vue";
//import Tiptap from "./Tiptap.vue";
import { updateStory } from "./APIManager.js";

export default {
    components: {
        SearchAnalysisWidget,
        SpendingPie,
        SpendingTree,
        SpendingScatter,
        SpendComparison,
        QuarterlyTrends,
        ResultsExpiryCycle
    },
    props:{
        data: Object,
        changed: Number,
        position: Number,
        reset:{
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            comp: Object,
            payload: Object,
            title: "",
            description:"",
            isMounted: false,
            timestamp: ""
        }
    },

    mounted(){
        this.loadStory();
    },

    computed:{

        description_html(){
            let html = '<p style="font-weight:normal; font-size:2.125rem;">'+this.description+'</p>';
            return html;
        },

        title_html(){
            let html = '<p style="font-weight:normal; font-size:2.125rem;">'+this.title+'</p>';
            return html;
        }

    },

    methods:{

        formatTimestamp(timestamp) {
            const date = new Date(timestamp);

            const year = date.getFullYear();
            const month = date.getMonth() + 1; 
            const day = date.getDate();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();

            const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;

            return formattedDate;
        },

        async saveUpdate(content){

            var story = this.data;
            
            if (content.sectionType === "heading"){
                story.title = content.html;
            }else{
                story.description = content.html;
            }

            await updateStory(story);
        },

        close(args){
            this.$emit("close", args);
        },

        loadStory(){

            this.comp = {};
            this.payload = {};
            this.title="",
            this.description = "";
            this.timestamp = "";

            if (this.data.chart_type == "spending-comparison")
            {
                this.comp = SpendComparison;
            }
            else if (this.data.chart_type == "market-share")
            {
                this.comp = SpendingPie;
            }
            else if (this.data.chart_type == "government-spending-breakdown")
            {
                this.comp = SpendingTree;
            }
            else if (this.data.chart_type == "contract-distribution")
            {
                this.comp = SpendingScatter;
            }
            else if (this.data.chart_type == "expiring-soon")
            {
                this.comp = ResultsExpiryCycle;
            }
            else if (this.data.chart_type == "market-activity")
            {
                //////////////console.log("PAYLOAD: ", this.data.payload)
                this.comp = SearchAnalysisWidget;
            }
            else if (this.data.chart_type == "quarterly-trends")
            {
                //////////////console.log("PAYLOAD: ", this.data.payload)
                this.comp = QuarterlyTrends;
            }

            //this.payload = this.data.payload;
            this.title = this.data.title;
            this.description = this.data.description;
            this.timestamp = (this.data.created) ? this.formatTimestamp(this.data.created) : this.formatTimestamp(new Date());
            //this.timestamp = this.formatTimestamp(this.data.created);
            this.isMounted = true;
            //this.$emit("isMounted", true);
        }
    },

    watch: {
        changed() {
            this.isMounted = false;
            this.loadStory();
        },

        /* async position(){
            await updateStory(this.data);
        } */
    },
}
</script>